import { IconButton } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import { useEffect } from 'react';
import useSignal from '../../hooks/useSignal';
import PanToolIcon from '@material-ui/icons/PanTool';
import { useDispatch, useSelector } from 'react-redux';

export default function ReactionsButton({ reactionHand, classes, room }) {
  //const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  //const [active, setActive] = useState(false);

  const state = useSelector((state) => state.videoRoomReducer);

  //const open = Boolean(anchorEl);
  const { sendSignal } = useSignal({ room });

  // const handleClick = (event) => {
  //   // setAnchorEl(event.currentTarget);
  //   dispatch({'type':SET_RAISE_HAND,'payload': !state.raiseHand})
  //   //setActive(!active)
  //   sendSignal('raisedHand', 'emoji', state.raiseHand)
  //   // toast('Raised Hand!');
  // };

  useEffect(() => {
    sendSignal('raisedHand', 'emoji', state.raiseHand);
  }, [state.raiseHand]);

  return (
    <div>
      <Tooltip title='Raise Hand'>
        <IconButton
          aria-label='more'
          aria-controls='long-menu'
          aria-haspopup='true'
          className={`${classes.toolbarButtons} ${
            !state.raiseHand ? '' : classes.disabledButton
          }`}
          onClick={reactionHand}
        >
          <PanToolIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
}
